import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs, { Dayjs } from "dayjs"

export interface ISelectedTimeSlot {
  fullName: string | null
  userId: number | null
  id: number | null
  date: Dayjs | string
  endDate: Dayjs | null
  startDate: Dayjs | null
  comment: string | null
  isDeletable: boolean | null
  isEditable: boolean | null
  type: {
    id: number | null
    name: string | null
  }
  usersPut: IusersPut[]
  limit: number
  usersCount: number
}

export interface IusersPut {
  id: number | null
  name: null | string
  status?: string | null
  eliminationStage?: string | null
}

export interface IDate {
  date: Dayjs
}

const SelectedTimeSlotState: ISelectedTimeSlot = {
  fullName: null,
  userId: null,
  id: null,
  date: dayjs().format("DD/MM/YYYY"),
  endDate: null,
  startDate: null,
  isDeletable: null,
  comment: null,
  isEditable: null,
  type: {
    id: null,
    name: null,
  },
  usersPut: [{ id: null, name: null }],
  limit: 10,
  usersCount: 0,
}

const selectedTimeSlotSlice = createSlice({
  name: "selectedTimeSlot",
  initialState: SelectedTimeSlotState,
  reducers: {
    setSelectedTimeSlotState: (
      state,
      action: PayloadAction<ISelectedTimeSlot>,
    ) => {
      state.date = action.payload.date
      state.id = action.payload.id
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
      state.isDeletable = action.payload.isDeletable
      state.isEditable = action.payload.isEditable
      state.type.id = action.payload.type.id
      state.type.name = action.payload.type.name
      state.usersPut = action.payload.usersPut
      state.limit = action.payload.limit
      state.usersCount = action.payload.usersCount
      state.comment = action.payload.comment
    },

    setSelectedDate: (state, action: PayloadAction<Dayjs>) => {
      state.date = action.payload
    },
    setSelectedfullName: (state, action: PayloadAction<string>) => {
      state.fullName = action.payload
    },
    setSelecteduserId: (state, action: PayloadAction<number>) => {
      state.userId = action.payload
    },
  },
})

export const selectedTimeSlotReducer = selectedTimeSlotSlice.reducer

export const {
  setSelectedTimeSlotState,
  setSelectedDate,
  setSelectedfullName,
  setSelecteduserId,
} = selectedTimeSlotSlice.actions
